import { render, staticRenderFns } from "./franchise-qty-points.vue?vue&type=template&id=1ea765f0"
import script from "./franchise-qty-points.vue?vue&type=script&lang=js"
export * from "./franchise-qty-points.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports